
import { Component, Prop, Vue } from 'vue-property-decorator';
import { SearchModule } from '~/store/modules/search';

@Component
export default class Users extends Vue {

    @Prop() readonly users!: Array <{ id: string, email: string }>;
    @Prop({default: ''}) readonly title!: string;

    navigateToUser(userMail: string) {
        SearchModule.search({ searchText: userMail, paramType: 'user_mail', prefix: 'legrand://' });
    }
}
